"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.grantsMap = exports.userUrl = exports.emergingAccountsUrl = exports.checkPointARUrl = exports.exitViewPortalUrl = exports.viewPortalUrl = exports.ssoUrl = exports.sessionAndBindingsUrl = exports.sessionBindingsUrl = exports.sessionJWTUrlV2 = exports.sessionMetadataUrlV2 = exports.sessionMetadataUrl = exports.authWaypointUrl = exports.cookiePath = exports.sambaDestUrl = exports.refAccountantMyPayOnboardingUrl = exports.clientMyPayOnboardingUrl = exports.esalesCustomerDestUrl = exports.employerDestUrl = exports.employeeDestUrl = exports.atendimentoClientDestUrl = exports.clientBetaDestUrl = exports.clientDestUrl = exports.defaultDestinationUrl = exports.staffDestUrl = exports.csWebLoginUriMap = exports.httpTimeout = exports.ssoTokenKey = exports.destinationStorageKey = exports.destinationQueryStringKey = exports.tokenType = void 0;
var tokenType = 'UDSLongToken';
exports.tokenType = tokenType;
var destinationQueryStringKey = 'd';
exports.destinationQueryStringKey = destinationQueryStringKey;
var destinationStorageKey = 'bmViewPortalReturnUrl';
exports.destinationStorageKey = destinationStorageKey;
var ssoTokenKey = 'token';
exports.ssoTokenKey = ssoTokenKey;
var httpTimeout = '60000';
exports.httpTimeout = httpTimeout;
var csWebLoginUriMap = {
  CI: 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
  DEMO: 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
  LOCAL: 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
  PROD: 'https://cs.thomsonreuters.com/myaccount/login.aspx',
  QED: 'https://cswebqa.int.thomsonreuters.com/myaccount/login.aspx',
  UNKNOWN: 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx'
};
exports.csWebLoginUriMap = csWebLoginUriMap;
var staffDestUrl = '/staff/';
exports.staffDestUrl = staffDestUrl;
var defaultDestinationUrl = staffDestUrl;
exports.defaultDestinationUrl = defaultDestinationUrl;
var clientDestUrl = '/client/';
exports.clientDestUrl = clientDestUrl;
var clientBetaDestUrl = '/clientcenter/';
exports.clientBetaDestUrl = clientBetaDestUrl;
var atendimentoClientDestUrl = '/atendimento-client/';
exports.atendimentoClientDestUrl = atendimentoClientDestUrl;
var employeeDestUrl = '/samba-employee-center/';
exports.employeeDestUrl = employeeDestUrl;
var employerDestUrl = '/samba-employer-center/';
exports.employerDestUrl = employerDestUrl;
var esalesCustomerDestUrl = '/samba-esales-customer-center/';
exports.esalesCustomerDestUrl = esalesCustomerDestUrl;
var clientMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/client';
exports.clientMyPayOnboardingUrl = clientMyPayOnboardingUrl;
var refAccountantMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/accountant';
exports.refAccountantMyPayOnboardingUrl = refAccountantMyPayOnboardingUrl;
var sambaDestUrl = '/smb/';
exports.sambaDestUrl = sambaDestUrl;
var cookiePath = '/';
exports.cookiePath = cookiePath;
var authWaypointUrl = '/login/';
exports.authWaypointUrl = authWaypointUrl;
var sessionMetadataUrl = '/api/security/v1/sessions';
exports.sessionMetadataUrl = sessionMetadataUrl;
var sessionMetadataUrlV2 = '/api/security/v2/sessions';
exports.sessionMetadataUrlV2 = sessionMetadataUrlV2;
var sessionJWTUrlV2 = '/api/security/v2/sessions/jwt';
exports.sessionJWTUrlV2 = sessionJWTUrlV2;
var sessionBindingsUrl = '/api/security/v1/session-bindings';
exports.sessionBindingsUrl = sessionBindingsUrl;
var sessionAndBindingsUrl = '/api/security/v1/session-and-bindings';
exports.sessionAndBindingsUrl = sessionAndBindingsUrl;
var ssoUrl = '/api/security/v1/sso';
exports.ssoUrl = ssoUrl;
var viewPortalUrl = '/api/security/v2/sessions/view-portal';
exports.viewPortalUrl = viewPortalUrl;
var exitViewPortalUrl = '/api/security/v1/sessions/view-portal/exit';
exports.exitViewPortalUrl = exitViewPortalUrl;
var checkPointARUrl = '/sso/';
exports.checkPointARUrl = checkPointARUrl;
var emergingAccountsUrl = '/ustax/#/dashboard';
exports.emergingAccountsUrl = emergingAccountsUrl;
var userUrl = '/api/profiles/v1/users';
exports.userUrl = userUrl;
var grantsMap = {
  'Applications.Onvio': 'staff',
  'OnvioSetup.Contacts': 'staff.setup.contacts',
  'OnvioSetup.Messages': 'staff.setup.messages',
  'OnvioSetup.Appearances': 'staff.setup.appearances',
  'OnvioSetup.Offices': 'staff.setup.offices',
  'OnvioSetup.Staff': 'staff.setup.staff',
  'OnvioSetup.Clients': 'staff.setup.clients',
  'OnvioSetup.Firm': 'staff.setup.firm',
  'OnvioDrive.Documents': 'staff.documents',
  'OnvioDrive.FirmDocuments': 'staff.documents.firm',
  'OnvioDrive.MyDocuments': 'staff.documents.my',
  'OnvioDrive.ClientDocuments': 'staff.documents.client',
  'Platform.ccVnext': 'client.beta',
  'Applications.OnvioClientHub': 'client',
  'OnvioClientDrive.Drive': 'client.documents',
  'TaxCenter.Tax': 'client.tax',
  'MyPayClientOnboarding.ClientOnboarding': 'client.mypayonboarding',
  'MyPayOnboarding.ReferringAccountant': 'staff.mypayonboarding.refaccountant',
  'Applications.Samba': 'samba',
  'SaMBa.Employee': 'samba.employee.center',
  'SaMBa.Employer': 'samba.employer.center',
  'SaMBa.ESalesCenter': 'samba.employer.center',
  'SaMBa.ESalesCustomerCenter': 'samba.esales.customer.center',
  'AuthApp.UberAdmin': 'csadmin',
  'AuthApp.Admin': 'csadmin',
  'AuthApp.Staff': 'csadmin',
  'USTax.PlatformEA': 'emergingaccounts'
};
exports.grantsMap = grantsMap;
